<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post20-stratotanker-mission-01-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post20-stratotanker-mission-01-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.90817716296806;"
    data-aspect-ratio="0.908"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post20-stratotanker-mission-01-xs-img"
      class="g-post20-stratotanker-mission-01-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-mission-01-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.9703%;margin-top:-9.7px;left:29.4354%;margin-left:-14px;width:28px;"
    >
      <p class="g-pstyle1">1</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:23.5524%;margin-top:-8.6px;right:66.8501%;width:94px;"
    >
      <p class="g-pstyle2">Rendezvous</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs"
      style="top:26.6949%;right:66.6354%;width:28.4848%;"
    >
      <p class="g-pstyle3">
        The fighter climbs or moves into position along a planned refueling
        track.
      </p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:46.1192%;margin-top:-8.6px;left:42.9415%;width:65px;"
    >
      <p class="g-pstyle0">Fighter</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:64.0304%;margin-top:-9.7px;left:53.7118%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle1">2</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.5389%;margin-top:-8.6px;left:51.9962%;width:84px;"
    >
      <p class="g-pstyle0">Formation</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs"
      style="top:75.6814%;left:51.9962%;width:40.9091%;"
    >
      <p class="g-pstyle4">
        It settles behind and slightly below the KC‑135, holding a steady
        formation.
      </p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.2417%;margin-top:-8.6px;left:70.0429%;width:63px;"
    >
      <p class="g-pstyle0">KC-135</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post20-stratotanker-mission-01-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.65364785689742;"
    data-aspect-ratio="1.654"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post20-stratotanker-mission-01-sm-img"
      class="g-post20-stratotanker-mission-01-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-mission-01-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.4276%;margin-top:-9.7px;left:28.9781%;margin-left:-14px;width:28px;"
    >
      <p class="g-pstyle1">1</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:24.1825%;margin-top:-8.6px;right:68.6185%;width:94px;"
    >
      <p class="g-pstyle2">Rendezvous</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs"
      style="top:27.885%;right:68.631%;width:31.7647%;"
    >
      <p class="g-pstyle3">
        The fighter climbs or moves into position along a planned refueling
        track.
      </p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:49.1763%;margin-top:-9.7px;left:70.2271%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle1">2</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:59.2009%;margin-top:-8.6px;left:69.1169%;width:84px;"
    >
      <p class="g-pstyle0">Formation</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs"
      style="top:62.9035%;left:69.117%;width:26.4706%;"
    >
      <p class="g-pstyle4">
        It settles behind and slightly below the KC‑135, holding a steady
        formation.
      </p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:68.604%;margin-top:-8.6px;left:34.6212%;width:65px;"
    >
      <p class="g-pstyle0">Fighter</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:13.1582%;margin-top:-8.6px;left:77.2082%;width:63px;"
    >
      <p class="g-pstyle0">KC-135</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post20-stratotanker-mission-01-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.88971915190887;"
    data-aspect-ratio="1.89"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post20-stratotanker-mission-01-md-img"
      class="g-post20-stratotanker-mission-01-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-mission-01-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:25.1001%;margin-top:-9.7px;left:26.214%;margin-left:-14px;width:28px;"
    >
      <p class="g-pstyle1">1</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:31.9718%;margin-top:-9.7px;right:71.8293%;width:105px;"
    >
      <p class="g-pstyle2">Rendezvous</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs"
      style="top:35.2175%;right:71.9384%;width:24.5455%;"
    >
      <p class="g-pstyle3">
        The fighter climbs or moves into position along a planned refueling
        track.
      </p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:46.5742%;margin-top:-9.7px;left:36.9292%;width:71px;"
    >
      <p class="g-pstyle0">Fighter</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:49.151%;margin-top:-9.7px;left:69.2016%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle1">2</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.7407%;margin-top:-9.7px;left:68.3437%;width:93px;"
    >
      <p class="g-pstyle0">Formation</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs"
      style="top:61.2727%;left:68.3437%;width:22.5758%;"
    >
      <p class="g-pstyle4">
        It settles behind and slightly below the KC‑135, holding a steady
        formation.
      </p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:8.2071%;margin-top:-9.7px;left:54.499%;width:69px;"
    >
      <p class="g-pstyle0">KC-135</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post20-stratotanker-mission-01-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 2.83816648447491;"
    data-aspect-ratio="2.838"
    data-min-width="930"
  >
    <div
      id="g-post20-stratotanker-mission-01-lg-img"
      class="g-post20-stratotanker-mission-01-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-mission-01-lg.jpg);"
    ></div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:14.5461%;margin-top:-9.7px;left:29.3768%;margin-left:-14px;width:28px;"
    >
      <p class="g-pstyle1">1</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:21.5652%;margin-top:-9.7px;right:69.2346%;width:105px;"
    >
      <p class="g-pstyle2">Rendezvous</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-text g-aiAbs"
      style="top:25.3299%;right:69.312%;width:17.4194%;"
    >
      <p class="g-pstyle3">
        The fighter climbs or moves into position along a planned refueling
        track.
      </p>
    </div>
    <div
      id="g-ai3-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.9604%;margin-top:-9.7px;left:36.9199%;width:71px;"
    >
      <p class="g-pstyle0">Fighter</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.5572%;margin-top:-9.7px;left:60.9971%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle1">2</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:59.7126%;margin-top:-9.7px;left:60.3884%;width:93px;"
    >
      <p class="g-pstyle0">Formation</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-text g-aiAbs"
      style="top:63.4773%;left:60.3884%;width:16.0215%;"
    >
      <p class="g-pstyle4">
        It settles behind and slightly below the KC‑135, holding a steady
        formation.
      </p>
    </div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:14.2409%;margin-top:-9.7px;left:53.6123%;width:69px;"
    >
      <p class="g-pstyle0">KC-135</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-18 12:24 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-18 12:24 -->
<!-- ai file: post20-stratotanker-mission-01.ai -->
<style lang="scss">
  #g-post20-stratotanker-mission-01-box {
    container-type: inline-size;
    container-name: g-post20-stratotanker-mission-01-box;
  }
  #g-post20-stratotanker-mission-01-box,
  #g-post20-stratotanker-mission-01-box .g-artboard {
    margin: 0 auto;
  }
  #g-post20-stratotanker-mission-01-box p {
    margin: 0;
  }
  #g-post20-stratotanker-mission-01-box .g-aiAbs {
    position: absolute;
  }
  #g-post20-stratotanker-mission-01-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post20-stratotanker-mission-01-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post20-stratotanker-mission-01-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post20-stratotanker-mission-01-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post20-stratotanker-mission-01-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post20-stratotanker-mission-01-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post20-stratotanker-mission-01-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post20-stratotanker-mission-01-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-post20-stratotanker-mission-01-lg {
        display: block !important;
      }
    }
  }
  #g-post20-stratotanker-mission-01-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-mission-01-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-mission-01-xs .g-pstyle0 {
    font-weight: 500;
    height: 16px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-01-xs .g-pstyle1 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-01-xs .g-pstyle2 {
    font-weight: 500;
    height: 16px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-01-xs .g-pstyle3 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-01-xs .g-pstyle4 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-01-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-mission-01-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-mission-01-sm .g-pstyle0 {
    font-weight: 500;
    height: 16px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-01-sm .g-pstyle1 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-01-sm .g-pstyle2 {
    font-weight: 500;
    height: 16px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-01-sm .g-pstyle3 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-01-sm .g-pstyle4 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-01-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-mission-01-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-mission-01-md .g-pstyle0 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-01-md .g-pstyle1 {
    font-weight: 700;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-01-md .g-pstyle2 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-01-md .g-pstyle3 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-01-md .g-pstyle4 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-01-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-mission-01-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-mission-01-lg .g-pstyle0 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-01-lg .g-pstyle1 {
    font-weight: 700;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-01-lg .g-pstyle2 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-01-lg .g-pstyle3 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-01-lg .g-pstyle4 {
    font-weight: 300;
    padding-bottom: 9px;
  }

  /* Custom CSS */
</style>
